module.exports = require("./vi-VN.js");